import { useQuery } from '@tanstack/react-query';
import { homeAPI } from '../api/homeAPI';
import { menuListAdapter } from '../libs/menuAdapter';
import { IMenuList } from '../types/Menu';

export const useProductSearch = (branch: number | undefined, query: string) => {
  const trimmed = query.trim();

  const { data, isLoading, isFetching } = useQuery({
    queryKey: ['product-search', branch, trimmed],
    queryFn: async () => {
      const res = await homeAPI.searchProducts(branch!, trimmed);
      return menuListAdapter(res.data as IMenuList[]);
    },
    enabled: !!branch && trimmed.length > 0,
    staleTime: 0,
  });

  return {
    searchResults: data ?? [],
    isSearching: isLoading || isFetching,
  };
};
